{"id":"OrderMageBranding","prefabs":{"default":{"children":[{"component":"OrderMageBranding","options":"options:*"}]}}}